// Copyright ©️ 2026 eVolve MEP, LLC

import type { WorkOrderPaginated } from '@evolvemep/api-ts';
import { Text } from '@mantine/core';

import type { ModalRegistryManagedProps } from 'components/Mantine/Modals/createModalRegistry';
import { WrappedModal } from 'components/Mantine/Modals/WrappedModal';
import { getDisplayNameWO } from 'modules/Shop/WorkOrders/WorkOrderDetail/common';
import { useWorkOrders } from 'modules/Shop/WorkOrders/WorkOrdersPage/useWorkOrders';

type Props = ModalRegistryManagedProps & {
  workOrder: WorkOrderPaginated;
  onWorkOrderActioned: () => void;
};

export const DeleteWorkOrderModal = ({ workOrder, onWorkOrderActioned, ...props }: Props) => {
  const { deleteWorkOrder } = useWorkOrders();

  const onSubmit = async () => {
    await deleteWorkOrder(workOrder.workOrderId);
    onWorkOrderActioned();
  };

  return (
    <WrappedModal title="Delete work order" onConfirm={onSubmit} size="sm" confirmationText="Delete" {...props}>
      <Text>
        Are you sure you want to delete work order <b>{getDisplayNameWO(workOrder)}</b>? This action cannot be undone.
      </Text>
    </WrappedModal>
  );
};
